<template>
  <article class="card" @click="redirectTo(product.url)">
    <div class="card-image">
      <img :src="product.image" />
    </div>
    <div class="card-name">
      <span>{{ product.name }}</span>
      <span><i class="fas fa-chevron-right"></i></span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'EcommerceFilterCard',
  components: {},
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    redirectTo(url) {
      window.location.href = url;
    },
  },
};
</script>

<style scoped>
.card {
  flex: 0 1 24%;
  cursor: pointer;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.card-image img {
  border-radius: 2px;
}
.card-name {
  flex: 1;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
img {
  display: block;
  border: 0;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// Card.vue?00e8132b